import React from "react";

const InfoCard = ({ icon, title, subtitle, value, flex = 1, variant = "default" }) => {
  const getCardStyle = () => {
    const baseStyle = {
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      borderRadius: "12px",
      padding: "12px",
      color: "white",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      flex: flex,
    };

    if (variant === "school") {
      return {
        ...baseStyle,
        justifyContent: "flex-start",
        alignItems: "center",
        display: "flex",
      };
    }

    return {
      ...baseStyle,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    };
  };

  const renderSchoolCard = () => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "12px",
          fontSize: "18px",
        }}
      >
        {icon}
      </div>
      <div>
        <h3 style={{ margin: 0, fontSize: "24px", fontWeight: "600", marginBottom: "2px" }}>{title}</h3>
        {subtitle && <p style={{ margin: 0, opacity: 0.9, fontSize: "12px" }}>{subtitle}</p>}
      </div>
    </div>
  );

  const renderDefaultCard = () => (
    <>
      <div style={{ fontSize: "14px", opacity: 0.8, marginBottom: "4px" }}>{title}</div>
      <div style={{ fontSize: "24px", fontWeight: "bold" }}>{value}</div>
    </>
  );

  return <div style={getCardStyle()}>{variant === "school" ? renderSchoolCard() : renderDefaultCard()}</div>;
};

export default InfoCard;
